import React, { useEffect, useMemo, useState } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const isActive = (pathname, item) => {
  if (item.match) return item.match(pathname);
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
};

function NavbarMenu({ onNavigate }) {
  const location = useLocation();
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("call-center-admin-token"));
    setUserType(user?.userType || "");
  }, []);

  const sections = useMemo(() => {
    const items = [
      {
        title: "Overview",
        items: [
          {
            key: "dashboard",
            to: "/",
            icon: "fa fa-desktop",
            label: "Dashboard",
            match: (p) => p === "/",
          },
        ],
      },
      {
        title: "Complaints",
        items: [
          {
            key: "addComplaint",
            to: "/add-complain",
            icon: "fa fa-plus",
            label: "Add Complaint",
          },
          {
            key: "viewComplain",
            to: "/view-complain",
            icon: "fa fa-id-card-o",
            label: "View Complaint",
          },
        ],
      },
      {
        title: "Reports",
        items: [
          {
            key: "pendencyReport",
            to: "/pendency?type=STATE&code=0&category=all",
            icon: "fa fa-bar-chart",
            label: "Daily Summary",
            match: (p) => p === "/pendency",
          },
          {
            key: "pendencyCatReport",
            to: "/pendency-category?type=STATE&code=0&category=New&date=",
            icon: "fa fa-pie-chart",
            label: "Category Summary",
            match: (p) => p === "/pendency-category",
          },
        ],
      },
    ];

    if (userType === "ADMIN") {
      items.push({
        title: "School & VC",
        items: [
          {
            key: "viewSchool",
            to: "/view-school",
            icon: "fa fa-building-o",
            label: "School Report",
          },
          {
            key: "vcReport",
            to: "/view-vc-report",
            icon: "fa fa-file-image-o",
            label: "View VC Report",
          },
          {
            key: "schoolVcReport",
            to: "/school-vc-report",
            icon: "fa fa-files-o",
            label: "School/VC Report",
          },
        ],
      });

      items.push({
        title: "Officer App",
        items: [
          {
            key: "sectionAccess",
            to: "/section-access",
            icon: "fa fa-key",
            label: "Section Access",
          },
        ],
      });

      items.push({
        title: "Users",
        items: [
          {
            key: "userList",
            to: "/user-list",
            icon: "fa fa-users",
            label: "User List",
          },
          {
            key: "createAccount",
            to: "/create-account",
            icon: "fa fa-user-plus",
            label: "Create Account",
          },
        ],
      });

      items.push({
        title: "Administration",
        items: [
          {
            key: "settings",
            to: "/settings",
            icon: "fa fa-cog",
            label: "Settings",
          },
        ],
      });
    }

    return items;
  }, [userType]);

  const pathname = location.pathname;

  return (
    <div>
      <div className="tab-content p-l-0 p-r-0">
        <div className="active" id="menu">
          <Nav id="left-sidebar-nav" className="sidebar-nav">
            <ul id="main-menu" className="metismenu">
              {sections.map((section) => (
                <li key={section.title} className="ccc-sidebar-section">
                  <p className="ccc-sidebar-section__title">{section.title}</p>
                  <ul>
                    {section.items.map((item) => (
                      <li
                        key={item.key}
                        className={
                          isActive(pathname, item) ? "activeClass" : ""
                        }
                      >
                        <Link
                          to={item.to}
                          onClick={() => onNavigate && onNavigate()}
                        >
                          <i className={item.icon} aria-hidden="true" />
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </Nav>
        </div>
      </div>
    </div>
  );
}

export default NavbarMenu;
